import { createFileRoute } from "@tanstack/react-router"
import { z } from "zod"

import { SignInForm } from "@/features/auth/components/sign-in-form"

const searchSchema = z.object({
  redirect: z.string().optional(),
})

export const Route = createFileRoute("/$organisation/_guest/login/")({
  validateSearch: searchSchema,
  component: LoginPage,
})

function LoginPage() {
  const { redirect } = Route.useSearch()

  return <SignInForm redirectTo={redirect} />
}
